import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service, ApiResponseModel, ResponseUtilityService } from '@zayan-erp/shared';
import { map, Observable } from 'rxjs';
import { TaxAuthority, TaxAuthorityCreate, TaxAuthorityUpdate } from '../models/tax-authority.models';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TaxAuthorityService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readTaxAuthorities(countryId?: string, provinceId?: string): Observable<TaxAuthority[]> {
    let params = new HttpParams();
    if (countryId) {
      params.set('countryId', countryId);
    }
    if (provinceId) {
      params.set('provinceId', provinceId);
    }
    return this.#http.getData(`${this.baseUrl}/TaxAuthority`, {
      showLoader: true,
      showMessage: false,
      options: { params }
    });
  }

  getTaxAuthorityById(id: string): Observable<TaxAuthority> {
    return this.#http.getData(`${this.baseUrl}/TaxAuthority/${id}`, { showLoader: true, showMessage: false });
  }

  createTaxAuthority(taxAuthority: TaxAuthorityCreate): Observable<TaxAuthority> {
    return this.#http.postData(
      `${this.baseUrl}/TaxAuthority`,
      { showLoader: true, showMessage: true, message: 'Tax Authority created successfully' },
      taxAuthority
    );
  }

  updateTaxAuthority(id: string, taxAuthority: TaxAuthorityUpdate): Observable<TaxAuthority> {
    return this.#http.putData(`${this.baseUrl}/TaxAuthority/${id}`, taxAuthority, {
      showLoader: true,
      showMessage: true,
      message: 'Tax Authority updated successfully'
    });
  }

  deleteTaxAuthority(id: string): Observable<void> {
    return this.#http.deleteData(`${this.baseUrl}/TaxAuthority/${id}`, {
      showLoader: true,
      showMessage: true,
      message: 'Tax Authority deleted successfully'
    });
  }
}
